<div class="row mb-3">
  <div class="col-12 text-center">
    <h3 class="text-lg font-semibold">Opciones de entrega</h3>
  </div>
</div>

<!-- Start::desktop y tablet -->
<div class="row hidden sm:flex">
  <div
    class="col-6 flex align-items-center justify-content-center"
    (click)="openDeliveryModal()"
    style="cursor: pointer"
  >
    <div class="me-2">
      <i class="fas fa-truck fa-2x" style="color: #00549d"></i>
    </div>
    <div
      style="text-decoration: underline; font-weight: bold; font-size: 1rem"
    >
      Simula<br />tu entrega
    </div>
  </div>
  <!-- Por el momento estará oculto -->
  <!-- <div
    class="col-4 flex align-items-center justify-content-center"
    (click)="openPickupModal()"
    style="cursor: pointer"
  >
    <div class="me-2">
      <i class="fas fa-map-marker-alt fa-2x" style="color: #00549d"></i>
    </div>
    <div
      style="text-decoration: underline; font-weight: bold; font-size: 1rem"
    >
      Simula tu<br />retiro en tienda
    </div>
  </div> -->

  <div
    class="col-6 flex align-items-center justify-content-center"
    (click)="openPickupTodayModal()"
    style="cursor: pointer"
  >
    <div class="me-2">
      <i class="fas fa-box fa-2x" style="color: #00549d"></i>
    </div>
    <div
      style="text-decoration: underline; font-weight: bold; font-size: 1rem"
    >
      Simula tu<br />retiro en tienda
    </div>
  </div>
</div>
<!-- End::desktop y tablet -->

<!-- Start::mobile -->
<div class="row flex lg:hidden">
  <div
    class="col-12 flex align-items-center justify-content-start mb-3"
    (click)="openDeliveryModal()"
    style="cursor: pointer"
  >
    <div class="me-3" style="min-width: 40px">
      <i class="fas fa-truck fa-2x" style="color: #00549d"></i>
    </div>
    <div
      style="text-decoration: underline; font-weight: bold; font-size: 1rem"
    >
      Simula tu entrega
    </div>
  </div>
  <!-- Por el momento estará oculto -->
  <!-- <div
    class="col-12 flex align-items-center justify-content-start mb-3"
    (click)="openPickupModal()"
    style="cursor: pointer"
  >
    <div class="me-3" style="min-width: 40px">
      <i class="fas fa-map-marker-alt fa-2x" style="color: #00549d"></i>
    </div>
    <div
      style="text-decoration: underline; font-weight: bold; font-size: 1rem"
    >
      Simula tu retiro en tienda
    </div>
  </div> -->

  <div
    class="col-12 flex align-items-center justify-content-start"
    (click)="openPickupTodayModal()"
    style="cursor: pointer"
  >
    <div class="me-3" style="min-width: 40px">
      <i class="fas fa-box fa-2x" style="color: #00549d"></i>
    </div>
    <div
      style="text-decoration: underline; font-weight: bold; font-size: 1rem"
    >
      Simula tu retiro en tienda
    </div>
  </div>
</div>
<!-- End::mobile -->
